import React from 'react';
import { Container, Title, Text, Paper, Divider } from '@mantine/core';

const Impressum: React.FC = () => {
    return (
        <Container size="md" my="xl">
            <Title order={2}  mb="lg">
                Impressum
            </Title>

            {/* Company Info */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    LagerFirst
                </Title>
                <Text>
                    Eine Marke der MT Beteiligungsmanagement UG<br />
                    Am Glüsig 1C<br />
                    39365 Harbke
                </Text>
            </Paper>
            <Divider my="md" />

            {/* Representation */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    Vertreten durch:
                </Title>
                <Text>M. Tkocz</Text>
            </Paper>
            <Divider my="md" />

            {/* Contact */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    Kontakt
                </Title>
                <Text>Telefon: +49 162 4307 132</Text>
                <Text>
                    E-Mail:{' '}
                    <a href="mailto:info@lagerfirst.de" target="_blank" rel="noopener noreferrer">
                        info@lagerfirst.de
                    </a>
                </Text>
            </Paper>
            <Divider my="md" />

            {/* Umsatzsteuer-ID */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    Umsatzsteuer-ID
                </Title>
                <Text>
                    Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                    DE355639561
                </Text>
            </Paper>
            <Divider my="md" />

            {/* Registereintrag */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    Registereintrag
                </Title>
                <Text>
                    Registernummer: HRB 31819<br />
                    39576 Hansestadt Stendal
                </Text>
            </Paper>
            <Divider my="md" />

            {/* EU-Streitschlichtung */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    EU-Streitschlichtung
                </Title>
                <Text>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                    <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                        https://ec.europa.eu/consumers/odr/
                    </a>
                    .<br />
                    Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </Text>
            </Paper>
            <Divider my="md" />

            {/* Verbraucherstreitbeilegung */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    Verbraucherstreitbeilegung/Universalschlichtungsstelle
                </Title>
                <Text>
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </Text>
            </Paper>
            <Divider my="md" />

            {/* Medienquellen */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    Medienquellen
                </Title>
                <Text mb="sm">- Adobe Stock (stock.adobe.com)</Text>
                <Text>
                    888413266 | Victor Bertrand<br />
                    511231879 | Macrovector<br />
                    989194882 | Anomal<br />
                    345656874 | JonoErasmus<br />
                    201973585 | Jirapong<br />
                    617365826 | Smallroombigdream<br />
                    883660662 | The Little Hut<br />
                    548102491 | ipuwadol<br />
                    456171712 | jd-photodesign<br />
                    800243383 | Fatima Abdul Moiz<br />
                    458886622 | kirill_makarov<br />
                    1015919618 | Anjali<br />
                    93172106 | akiyoko<br />
                    485716876 | Pixel-Shot
                </Text>
            </Paper>
            <Divider my="md" />

            {/* Programmierung und Layout */}
            <Paper shadow="xs" p="md" withBorder mb="md">
                <Title order={4} mb="sm">
                    Programmierung und Layout
                </Title>
                <Text mb="sm">MACO Vision GmbH</Text>
                <Text>
                    Pulvergarten 1a<br />
                    38855 Wernigerode<br />
                    Tel.: 03943 20 966 02<br />
                    E-Mail:{' '}
                    <a href="mailto:info@maco-vision.com" target="_blank" rel="noopener noreferrer">
                        info@maco-vision.com
                    </a>
                    <br />
                    <a href="http://www.maco-vision.com" target="_blank" rel="noopener noreferrer">
                        www.maco-vision.com
                    </a>
                </Text>
            </Paper>
        </Container>
    );
};

export default Impressum;
